export default __webpack_public_path__ + "static/media/kidofa-white.19b933f6.png";